(() => {
  const header = document.querySelector('.review-scroll-header');
  if (!header) return;
  let height = header.offsetHeight;
  let previousY = Math.max(0, window.scrollY);
  let offset = -Math.min(previousY, height);
  let scheduled = false;
  const apply = () => header.style.setProperty('--header-offset', `${offset}px`);
  apply();
  header.classList.add('is-enhanced');
  const update = () => {
    scheduled = false;
    const y = Math.max(0, window.scrollY);
    const delta = y - previousY;
    if (y === 0 || header.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) offset = 0;
    else if (delta < -2) offset = 0;
    else if (delta > 2) offset = -Math.min(y, height);
    if (Math.abs(delta) > 2 || y === 0) previousY = y;
    apply();
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  header.addEventListener('focusin', (event) => {
    if (event.target.matches(':focus-visible')) { offset = 0; apply(); }
  });
  new ResizeObserver(() => {
    height = header.offsetHeight;
    offset = Math.max(offset, -height);
    apply();
  }).observe(header);
  window.addEventListener('pageshow', () => {
    previousY = Math.max(0, window.scrollY);
    offset = -Math.min(previousY, height);
    apply();
  });
})();
